import { createGtmEventsProxy } from '@/gtm/gtm-events-utils';

export default {
  inject: {
    gtmEvents: {
      default: createGtmEventsProxy(),
    },
  },
};
